export const verificarMultiploLoteMinimo = (valor, lote) => {
  if (!lote) return false;

  const qtd_compra = Number(valor).toFixed(4);
  const modulo = Number(qtd_compra % lote).toFixed(4);

  // if (localStorage.config_lote_minimo_a_partir_de === 'S' && Number(qtd_compra) >= Number(lote)) {
  //   return true;
  // }

  return (modulo == 0 || modulo === Number(lote).toFixed(4));
}
